import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme.js';
import './styles/main.css';
import AppRoutes from './routes/AppRoutes.jsx';
import FullPageMessage from './components/FullPageMessage.jsx';
import UserService from './auth/UserService.js';
import AppProviders from './AppProviders.jsx';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_PREMIUM_KEY);

const container = document.getElementById('root');
const root = createRoot(container);

const renderOnAuthenticated = () =>
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <AppProviders>
            <AppRoutes />
          </AppProviders>
          <CssBaseline />
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );

const renderOnUnauthenticated = () =>
  root.render(
    <ThemeProvider theme={theme}>
      <ErrorBoundary showErrorUI={true} />
    </ThemeProvider>
  );

const renderOnAuthenticatingCallback = () =>
  root.render(
    <FullPageMessage
      title="Authenticating..."
      showLoader={true}
    />
  );

UserService.initKeycloak(
  renderOnAuthenticated,
  renderOnUnauthenticated,
  renderOnAuthenticatingCallback
);
